import type { Pod } from "@/types";
import { createContext, useContext } from "react";

export interface ConfigContextType {
	bearerToken: string;
	pod: Pod | null;
}

export const ConfigContext = createContext<ConfigContextType | undefined>(
	undefined,
);

export function useConfig() {
	const context = useContext(ConfigContext);
	if (context === undefined) {
		throw new Error("useConfig must be used within a ConfigProvider");
	}
	return context;
}
